module.exports = __webpack_public_path__ + "img/290d9.b6579707.svg";